import { memo, useMemo } from "react";
import { PurchaseCampaign } from "./purchase-campaign";
import { PurchaseStageWakuWakuBanner } from "./purchase-stage-wakuwaku-banner";
import * as Styled from "./style";
import type { G_VideoCampaign, Maybe } from "~/lib/graphql";

type PurchaseTitleContentProps = {
  titleName: string;
  seasonName: string;
  isWakuwari: boolean | undefined;
  campaign: Maybe<Pick<G_VideoCampaign, "endAt" | "name">> | undefined;
};

/**
 * 購入モーダルで作品名を表示するコンポーネント
 *
 * @機能要件
 * - メインの場合 : シリーズ + シーズン名 を表示する
 * - グラビア・舞台・VRの場合 : 作品名 を表示する
 */
export const PurchaseTitleContent = memo((props: PurchaseTitleContentProps) => {
  const { titleName, seasonName, isWakuwari, campaign } = props;

  /**
   * ### 表示条件
   *
   * - 汎用CPのセール表記ある かつ イベント割設定がある場合 : 汎用CPのセール表記のみを表示する
   * - 汎用CPのセール表記ある かつ イベント割設定がない場合 : 汎用CPのセール表記のみを表示する
   * - 汎用CPのセール表記ない かつ イベント割設定がある場合 : イベント割セール表記のみを表示する
   * - 汎用CPのセール表記ない かつ イベント割設定がない場合 : なにも表示しない
   */
  const campaignComponent = useMemo(() => {
    if (campaign === undefined || campaign === null) {
      if (isWakuwari) return <PurchaseStageWakuWakuBanner isWakuwari={isWakuwari} />;
      return null;
    }

    if (new Date(campaign.endAt).getTime() < Date.now()) {
      if (isWakuwari) return <PurchaseStageWakuWakuBanner isWakuwari={isWakuwari} />;
      return null;
    }

    return <PurchaseCampaign campaign={campaign} />;
  }, [isWakuwari, campaign?.name, campaign?.endAt]);

  return (
    <>
      <Styled.HeadingSeasonTitle>{titleName}</Styled.HeadingSeasonTitle>
      {seasonName !== undefined && titleName !== seasonName && (
        <Styled.ParSeasonName>{seasonName}</Styled.ParSeasonName>
      )}
      {campaignComponent}
    </>
  );
});

PurchaseTitleContent.displayName = "PurchaseTitleContent";
